/**
 * Uygulamanın BİLEREK yaptığı yeniden yüklemeler (kilit, profil değişimi,
 * dil, kasa değişimi). Otomatik indirmenin "sayfadan ayrılmak istiyor
 * musunuz" sorusu bunlarda çıkmaz: indirilmemiş değişiklik kasada durur,
 * bir sonraki açılışta yeniden indirilir ya da bantla sorulur.
 */

let bilerek = false;

export function bilerekAyriliyorMu(): boolean {
  return bilerek;
}

export function bilerekYenile(): void {
  bilerek = true;
  globalThis.location?.reload();
}
